
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { BrowserModule } from '@angular/platform-browser';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BasicComponent } from './basic/basic.component';
import { BlankComponent } from './blank/blank.component';
import { NavigationModule } from '../navigation/navigation.module';
import { TopnavbarModule } from '../topnavbar/topnavbar.module';
import { ImageBannerModule } from '../imagebanner/imagebanner.module';

@NgModule({
    declarations: [BasicComponent, BlankComponent],
    imports     : [BrowserModule, RouterModule, NavigationModule, TopnavbarModule, ImageBannerModule, FormsModule],
    exports     : [BasicComponent, BlankComponent, FormsModule]
})

export class LayoutsModule {}



// WEBPACK FOOTER //
// ./src/app/common/layouts/layouts.module.ts